import { useState } from "react";
import { Modal, Box, Typography } from "@mui/material";

interface ExpandableImageProps {
  src: string;
  alt: string;
}

export default function ExpandableImage({ src, alt }: ExpandableImageProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Thumbnail-versio */}
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%", // responsiivinen alaspäin
          maxWidth: "600px", // thumbnail ei ylitä 600px
          height: "auto",
          cursor: "pointer",
          borderRadius: 8,
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        }}
        onClick={() => setOpen(true)}
      />

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: "block",
          marginTop: "8px",
          marginBottom: "15px",
        }}
      >
        Klikkaa kuvaa suurentaaksesi
      </Typography>

      {/* Modal: täysikokoinen versio */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            outline: "none",
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: "90vw", // mahtuu näytölle
              maxHeight: "90vh", // mahtuu näytölle
              height: "auto",
              borderRadius: 8,
            }}
          />
        </Box>
      </Modal>
    </>
  );
}
